import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-285077c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "footer"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "© Copyright 2017-2025 南京元感微电子有限公司版权所有 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "http://beian.miit.gov.cn/",
  rel: "noreferrer",
  target: "_blank"
}, " 苏ICP备2023000848号-2 ", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.mps.gov.cn/#/query/webSearch?code=32011202001349",
  rel: "noreferrer",
  target: "_blank"
}, "苏公网安备32011202001349", -1))

import { onMounted, onUnmounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  props: {
  // 是否展示底部footer
  showFooter: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {

const props = __props;

let img = require("@/assets/images/public-security-record.png");



// rem自适应 🐸🐸🐸🐸🐸🐸🐸🐸
// 定义适配函数
const reScreenSize = () => {
  let w = document.documentElement.clientWidth; // 获取设备的宽度
  // console.log("设备宽度是：", w);
  let newFontSize = 10 * (w / 1920); // 计算新的字体大小
  // 限制最大字体大小为40px，最小为7.4px
  newFontSize = Math.max(7.4, Math.min(newFontSize, 40));
  document.documentElement.style.fontSize = `${newFontSize}px`;
};

// 页面加载时执行一次适配
onMounted(() => {
  reScreenSize();
  window.addEventListener("resize", reScreenSize);
});

// 页面卸载时移除监听事件
onUnmounted(() => {
  window.removeEventListener("resize", reScreenSize);
});

return (_ctx: any,_cache: any) => {
  return (__props.showFooter)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("img", {
          src: _unref(img),
          alt: "南京元感微电子公安备案编号图标"
        }, null, 8, _hoisted_4),
        _hoisted_5
      ]))
    : _createCommentVNode("", true)
}
}

})